<div class="dialog">
  <div class="dialog-body">
    <p>
      Confirm or change the <strong>realm</strong> to synchronize your filters to. You can always change it later in the settings.
    </p>

    <div class="dialog-options">
      <div class="dialog-option preset-option" [class.selected]="selectedRealm === 'pc'" (click)="selectRealm('pc')">
        <h3 class="option-text">PC</h3>
      </div>
      <div class="dialog-option preset-option" [class.selected]="selectedRealm === 'xbox'" (click)="selectRealm('xbox')">
        <h3 class="option-text">XBOX</h3>
      </div>
      <div class="dialog-option preset-option" [class.selected]="selectedRealm === 'sony'" (click)="selectRealm('sony')">
        <h3 class="option-text">PlayStation</h3>
      </div>
    </div>

    <button type="button" class="btn dialog-btn" (click)="closeDialog()">
      Confirm Realm
    </button>
  </div>
</div>